import { useEffect, useRef } from 'preact/hooks';
import { sendReady, sendResize } from '../utils/postMessage';

export interface UseAutoResizeOptions {
  layout?: string;
  max_width?: number;
}

export function useAutoResize(opts?: UseAutoResizeOptions): void {
  const lastHeight = useRef(0);
  /* When desktop: use max_width if set, else 1200 (centered layout) */
  const maxWidth =
    opts?.layout === 'desktop'
      ? opts?.max_width ?? 1200
      : undefined;

  useEffect(() => {
    const check = () => {
      const h = document.documentElement.scrollHeight;
      if (h !== lastHeight.current) {
        lastHeight.current = h;
        sendResize(h, maxWidth);
      }
    };

    sendReady(document.documentElement.scrollHeight, maxWidth);
    lastHeight.current = document.documentElement.scrollHeight;

    const observer = new ResizeObserver(check);
    observer.observe(document.body);
    const interval = setInterval(check, 500);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, [maxWidth]);
}
